import {createFeature, StoreModule} from '@ngrx/store';
import {StoreKeys} from '../../../models/store-keys';
import { wkfSupervisionFilterReducer } from './reducer/wkf-supervision-filter.reducer';

export const wkfSupervisionFilterStoreConfig = StoreModule.forFeature(
  createFeature({
    name: StoreKeys.WKF_SUPERVISION_FILTERS,
    reducer: wkfSupervisionFilterReducer
  })
);
